import {
  downloadPdfContract,
  getDeliveryTypes,
  getRegisterStatus,
  getSoftwareTypes,
  identityVerification,
  loginWithNoPass,
  sendBankInfo,
  sendContract,
  sendDocument,
  sendFaceRecognitionInfo,
  sendIbanInfo,
  sendKycOtpCode,
  sendOtp,
  sendPersonalInfo,
  sendPostalInfo,
  sendSabtahvalInfo,
  sendSignatureInfo,
  sendVendorInfo
} from './thunk';

export const registerationBuilder = (builder: any) => {
  builder
    .addCase(getRegisterStatus.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getRegisterStatus.fulfilled, (state: any, action: any) => {
      state.registerStatus = action.payload;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getRegisterStatus.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(sendPersonalInfo.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(sendPersonalInfo.fulfilled, (state: any) => {
      // state.inprogressTickets = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(sendPersonalInfo.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(sendSabtahvalInfo.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(sendSabtahvalInfo.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(sendSabtahvalInfo.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(sendFaceRecognitionInfo.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(sendFaceRecognitionInfo.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(sendFaceRecognitionInfo.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(sendSignatureInfo.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(sendSignatureInfo.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(sendSignatureInfo.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(sendKycOtpCode.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(sendKycOtpCode.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(sendKycOtpCode.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(identityVerification.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(identityVerification.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(identityVerification.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(sendVendorInfo.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(sendVendorInfo.fulfilled, (state: any, action: any) => {
      state.doneTickets = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(sendVendorInfo.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(sendBankInfo.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(sendBankInfo.fulfilled, (state: any, action: any) => {
      state.ticket = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(sendBankInfo.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(sendPostalInfo.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(sendPostalInfo.fulfilled, (state: any, action: any) => {
      state.tags = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(sendPostalInfo.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(sendIbanInfo.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(sendIbanInfo.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(sendIbanInfo.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(sendDocument.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(sendDocument.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(sendDocument.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(sendContract.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(sendContract.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(sendContract.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  // builder.addCase(getStepNumber.pending, (state: any) => {
  //     state.stepNumberLoading = true;
  // }).addCase(getStepNumber.fulfilled, (state: any, action: any) => {
  //     console.log("action.payload.step", action.payload.step)
  //     state.stepNumber = action.payload.step;
  //     state.stepNumberLoading = false;
  // }).addCase(getStepNumber.rejected, (state: any) => {
  //     state.stepNumberLoading = false;
  // });

  builder
    .addCase(sendOtp.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(sendOtp.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(sendOtp.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(loginWithNoPass.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(loginWithNoPass.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(loginWithNoPass.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getSoftwareTypes.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getSoftwareTypes.fulfilled, (state: any, action: any) => {
      state.softwareTypes = action.payload.data.map((item: any) => {
        return {value: item.name, label: item.name};
      });
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getSoftwareTypes.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getDeliveryTypes.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getDeliveryTypes.fulfilled, (state: any, action: any) => {
      state.deliveryTypes = action.payload.data.map((item: any) => {
        return {value: item.name, label: item.name};
      });
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getDeliveryTypes.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(downloadPdfContract.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(downloadPdfContract.fulfilled, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(downloadPdfContract.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};
